import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

const reloadUnitSettingsAfterDbChange = (action$) =>
    action$.pipe(
        ofType(actionTypes.INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE),
        switchMap(({payload}) => {
            if (payload.database === null) {
                return [];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_USER_SETTINGS
                    },
                    method: handlers.RELOAD_USER_SETTINGS,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_COLORANTS
                    },
                    method: handlers.RELOAD_ALL_COLORANTS,
                    tabId: 0
                }
            ];
        })
    );

export default [reloadUnitSettingsAfterDbChange];
